import React from 'react';
import { Button, Input } from 'ui/mobile-ds';
import { UseFormRegister } from 'react-hook-form';
import {
  CLAIM_REASON_MAX_LENGTH,
  IClaimCreateFormSchema,
} from '@/store/claimCreateStore';

const TreatmentDetailsInput = React.forwardRef<
  HTMLInputElement,
  React.ComponentPropsWithRef<typeof Input> & {
    register: UseFormRegister<IClaimCreateFormSchema>;
    onDetailsSubmit: () => void;
  }
>((props, ref) => {
  const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = (
    event,
  ) => {
    const isEnterPressed = event.key === 'Enter';
    if (isEnterPressed) {
      event.preventDefault();
      event.stopPropagation();
      props.onDetailsSubmit();
    }
  };

  return (
    <>
      <Input
        required
        maxLength={CLAIM_REASON_MAX_LENGTH}
        onKeyDown={handleKeyDown}
        placeholder="e.g. Knee surgery"
        {...props.register('reasonForHospitalization', {
          required: true,
        })}
        {...props}
        ref={ref}
        containerClassName="!rounded-2xl focus-within:border-mobile-gray-500"
        className="!rounded-2xl outline-none py-5"
      />
      <Button
        onClick={() => {
          props.onDetailsSubmit();
        }}
        type="button"
        className="mt-2 md:mt-4 flex ml-auto"
      >
        Next
      </Button>
    </>
  );
});

TreatmentDetailsInput.displayName = 'TreatmentDetailsInput';

export default TreatmentDetailsInput;
